export default __webpack_public_path__ + "static/media/FileDescriptionBackground.1b9e7172.svg";